import React from "react";

var CaretRightDoubleIcon = function CaretRightDoubleIcon(props) {
  return /*#__PURE__*/React.createElement("svg", props, /*#__PURE__*/React.createElement("path", {
    d: "M11.595 7.414L16.254 12l-4.659 4.586c-.384.378-.595.88-.595 1.414s.211 1.036.595 1.414.894.586 1.437.586 1.053-.208 1.437-.586L22 12l-7.532-7.414C14.084 4.208 13.574 4 13.032 4s-1.053.208-1.437.586a1.982 1.982 0 0 0 0 2.828zM13 12L5.468 4.586C5.084 4.208 4.574 4 4.032 4s-1.053.208-1.437.586a1.98 1.98 0 0 0 0 2.828L7.254 12l-4.659 4.586C2.211 16.964 2 17.466 2 18s.211 1.036.595 1.414.894.586 1.437.586 1.053-.208 1.437-.586z"
  }));
};

CaretRightDoubleIcon.defaultProps = {
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
};
CaretRightDoubleIcon.defaultProps.solid = true;
export default CaretRightDoubleIcon;